export class flightManageBookingsSaves {
	useService: boolean = false;
	firstDay;
	lastDay;
	userB2B;
	isAdmin;
	customers;

	airlines;
	airports;

	/* bookings display */
	bookings = {
		bookings: null,
		originalBookings: null,
		tableBookings: null,
		totalePages: null,
	};

	/* date */
	date = {
		dateType: null,
		dateTypeValue: null,
	};

	/* mode */
	mode = {
		modeType: null,
		modeTypeValue: null,
	};

	/* agencies */
	agenciesData = {
		agencies: null,
		agenciesDPD: null,
		selectedAgencyValue: null,
		selectedAgency: null,
	};

	/* platform */
	platformsData = {
		platformsList: null,
		selectedPlatformValue: null,
		selectedPlatform: null,
		platformDPD: null,
	};

	/* validating carriers */
	validatingCarriersData = {
		validatingCarriersCodes: null,
		validatingCarriersLabels: null,
		selectedCompanyValue: null,
		selectedCompany: null,
	};

	/* agents */
	agentsData = {
		agents: null,
		agentsDPD: null,
		selectedAgentValue: null,
		selectedAgent: null,
	};

	/* status */
	statusData = {
		selectedStatus: null,
		selectedStatusValue: null,
	};

	/* zone */
	zoneData = {
		selectedZone: null,
		selectedZoneValue: null,
	};

	/* input text */
	customerName;
	paxName;
	eticketNumber;
	pnr;

	constructor() {}
}
